import UIList from 'UIComponents/list/UIList';
import FileActions from '../FileActions';
import FileAttachment from '../FileAttachment';
import StyledFileValueContainer from '../StyledFileValueContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FileResolvedValuesList = ({
  fileReferences,
  isEditDisabled,
  uploadsInProgress,
  onFileAction
}) => {
  return /*#__PURE__*/_jsx(UIList, {
    children: fileReferences.map((fileReference, index) => /*#__PURE__*/_jsxs(StyledFileValueContainer, {
      "data-test-id": fileReference.id,
      children: [/*#__PURE__*/_jsx(FileAttachment, {
        fileReference: fileReference
      }), /*#__PURE__*/_jsx(FileActions, {
        fileId: fileReference.id,
        disabled: isEditDisabled,
        index: index,
        totalFiles: fileReferences.length,
        uploadsInProgress: uploadsInProgress,
        onFileAction: onFileAction
      })]
    }, fileReference.id))
  });
};
export default FileResolvedValuesList;